import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/realms/rooms-list.tsx");
